import ErrorMessageBlock from '../ErrorMessageBlock.jsx';
import Linkify from '../Linkify.jsx';
import { ucfirst } from '../../lib/Utils.js';
import useBusinessPostApi from '../../lib/useBusinessPostApi.js';
import { setEventDetailsQuery } from '../../lib/Queries';

const EventLocation = ({ event, updateEvent }) => {
    const locationType = event?.event_type?.location?.type;
    const isVirtualMeeting =
        locationType === 'google' || locationType === 'zoom';

    const { save: saveGenerate, isSaving: isGenerating } = useBusinessPostApi(
        `/calendar/events/${event?.id}/location`,
    );

    function doGenerateLink() {
        saveGenerate({
            generate: true,
        }).then(result => {
            updateEvent(result);
        });
    }

    if (!event) {
        return null;
    }

    const hasNoLocation =
        !event.location || event.location.startsWith('Failed');

    return (
        <>
            {(!!event.location ||
                (locationType && locationType !== 'none')) && (
                <div>
                    <div className="panel-label">Location</div>
                    {!!event.settings && !!event.settings['location-error'] && (
                        <ErrorMessageBlock className="mb-1">
                            {event.settings['location-error']}
                        </ErrorMessageBlock>
                    )}
                    <div className="panel px-6 py-4">
                        <Linkify>{event.location}</Linkify>
                        {!event.location && !isVirtualMeeting && 'None'}

                        {isVirtualMeeting && hasNoLocation && (
                            <div>
                                <div className="mb-2">
                                    This event type is set up for{' '}
                                    {ucfirst(locationType)}, but there's no
                                    meeting link generated.
                                </div>
                                <button
                                    type="button"
                                    className="btn-light-pill"
                                    onClick={() => doGenerateLink()}
                                >
                                    {isGenerating
                                        ? 'Generating...'
                                        : 'Generate Meeting Link'}
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default EventLocation;
